import { getMessages } from '../../../../../../../store/constants';

export const LABEL_START_DATE = getMessages().getText('card_form_start_date');
export const LABEL_DUE_DATE = getMessages().getText('card_form_due_date');
